function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import clone from 'ramda/src/clone';
import uniq from 'ramda/src/uniq';
import { stateGo } from 'redux-ui-router';
import i18n from 'invision-core/src/components/i18n/i18n';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { PRODUCT_CLASSIFICATIONS } from 'invision-core/src/constants/product.constants';
import { retrieveOfferingsMetadata } from 'invision-core/src/components/metadata/offerings/offerings.actions';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { MetadataCodeLoadedSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import CustomerLocaleKeys from '../../../../../../locales/keys';
import { STATE_OR_NAME as ADD_OFFER_STATE } from '../../../../../../reducers/constants/add.offer.wizard.constants';
import { EDIT_OFFERING_INSTANCES, RECONNECT_OFFER_STATE_NAME, STATE_OR_NAME as EDIT_OFFER_STATE } from '../../../../../../reducers/constants/edit.offer.wizard.constants';
import { BLANK_PAYMENT_INSTRUMENT } from '../../../../makePayment/make.payment.constants';
import { CUSTOMER_REMOVE_OFFER_URL } from '../../../../offers/remove/remove.offer.config';
import { DISCONNECT_OFFERS_DBSS_ROUTE } from '../../../../offers/disconnect/dbss/disconnect.offers.dbss.config';
import { DISCONNECT_OFFERS_ITV_ROUTE } from '../../../../offers/disconnect/itv/disconnect.offers.itv.config';
import { STATE_NAME as TRANSITION_OFFER_STATE } from '../../../../orders/transition/transition.offer.wizard.constants';
import { OFFERINGS_STATE_NAME } from '../../../../offerings/offerings.config';
import { resumeOffer, searchSubscriberOfferings, setSelectedOfferName, startEditOfferFlow, suspendOffer } from '../../../../../../reducers/actions/offering.order.actions';
import { renewOffCycleCharges, retrieveAvailablePaymentInstrumentTypes, retrieveWallet, updateOfferingInstancePaymentInstrument } from '../../../../../../reducers/actions/customer.ewallet.actions';
import { fetchSubscriberProductServiceRelationships, updateSubscriberProductServiceRelationships } from '../../../../../../reducers/actions/product.service.relationships.actions';
import { ProductServiceRelationshipsSelector } from '../../../../../../reducers/selectors/product.service.relationships.selectors';
import { offerIsEligible } from '../../../../../../reducers/selectors/dashboard.selectors.helper';
import { CurrentCustomerIdSelector, RouteParams, RouteState } from '../../../../../../reducers/selectors/customer.selectors';
import { ChangeOfferEligibilityRulesSelector } from '../../../../../../reducers/selectors/customer.offerings.selectors';
import { HasSubscriberAdminAccessSelector } from '../../../../../../reducers/selectors/permissions.selectors';
import { PaymentInstrumentsCanBeUsedForOrderingWithTypeNamesViewModelSelector } from '../../../../../../reducers/selectors/customer.ewallet.selectors';
import { retrieveSubscriberOfferingDetail, updateLifeCycleDetails } from '../../../../../../reducers/actions/customer.actions';
import { LifeCyclePricingPlanDetailsSelector, PricingPlanInLifeCycleForOffersSelector } from '../../../../../../reducers/selectors/selected.offering.order.selectors';
import { SelectedSubscriberOfferingInstanceIdSelector, SearchSubscriberOfferingsDataSelector, OfferAdditionalPropertiesSelector } from '../../../../../../reducers/selectors/search.subscriber.offerings.selectors';
import { OfferingMetadataByIdSelector, OfferingMetadataPricingPlansSelector } from 'invision-core/src/components/metadata/offerings/offerings.selectors';
import { getOrderIdAndSubscriberProductIds } from '../../../../../../reducers/helpers/off.cycle.helpers';
import { AUTO_RENEW_ACTION_TYPES, AUTO_RENEW_ENTITY_TYPES, ORDER_TYPE_CODE } from '../../../../../../customercare.constants';
import { SelectedServiceDetailsOfferOrderedOfferingAdditionalPropertiesSelector, SelectedServiceDetailsOfferOrderedOffering, SelectedServiceDetailsSelector } from '../../../../../../reducers/selectors/selected.service.details.selectors';
import { MENU_ITEMS } from '../../dashboard.constants';
import { PRICING_PLAN_EARLY_RENEWAL_REDIRECT, RESUME_SUBSCRIBER_PRODUCTS_REDIRECT, SUSPEND_SUBSCRIBER_PRODUCTS_REDIRECT } from '../../../../../../reactRoutes';
import { OFFERING_OPTION_STATUSES } from '../../../../../shared/constants/offering.option.status.constants';
var OfferDetailsController = /*#__PURE__*/function () {
  function OfferDetailsController($ngRedux, $state, $timeout, uiNotificationService) {
    _classCallCheck(this, OfferDetailsController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $state: $state,
      $timeout: $timeout,
      CustomerLocaleKeys: CustomerLocaleKeys,
      closeOfferingAutoRenewChangeModal: this.closeOfferingAutoRenewChangeModal.bind(this),
      handleCloseEditAdditionalProperties: this.handleCloseEditAdditionalProperties.bind(this),
      closeSuspendResumeModal: this.closeSuspendResumeModal.bind(this),
      isEditingPaymentInstrument: false,
      isExpanded: false,
      isModifyPaymentMethodPopupShown: false,
      isOfferingAutoRenewChangeModalOpen: false,
      isSuspendResumeModalOpen: false,
      modalPaymentMethod: {},
      offeringAutoRenewAction: null,
      offeringAutoRenewEntityType: null,
      pricingPlanExpiryAutoRenew: null,
      onCloseProductServiceRelationshipsModal: this.onCloseProductServiceRelationshipsModal.bind(this),
      onMoreItemSelected: this.onMoreItemSelected.bind(this),
      onOfferingAutoRenewChangeSubmit: this.onOfferingAutoRenewChangeSubmit.bind(this),
      onSubmitProductServiceRelationshipsModal: this.onSubmitProductServiceRelationshipsModal.bind(this),
      openLifeCycleDetailsPopup: this.openLifeCycleDetailsPopup.bind(this),
      navigateToPricingPlanEarlyRenewal: this.navigateToPricingPlanEarlyRenewal.bind(this),
      submitAdditionalProperties: this.submitAdditionalProperties.bind(this),
      submitSuspendResume: this.submitSuspendResume.bind(this),
      suspendResumeOrderType: +ORDER_TYPE_CODE.SUSPEND,
      suspendResumeModalTitle: '',
      suspendResumeFormInstruction: '',
      suspendResumeOfferId: null,
      PRODUCT_CLASSIFICATIONS: PRODUCT_CLASSIFICATIONS,
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(OfferDetailsController, [{
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      var _this = this;
      var subscriberOfferIds = [];
      if (changesObj.offer.currentValue && changesObj.offer.currentValue.Options) {
        changesObj.offer.currentValue.Options.forEach(function (option) {
          if (option.SubscriberProductServiceRelationship && option.SubscriberProductServiceRelationship.ProviderOfferingId && option.SubscriberProductServiceRelationship.ProviderOfferingId.Value && !subscriberOfferIds.includes(option.SubscriberProductServiceRelationship.ProviderOfferingId.Value)) {
            subscriberOfferIds.push(option.SubscriberProductServiceRelationship.ProviderOfferingId.Value);
          }
        });
      }
      if (changesObj.offer.currentValue && changesObj.offer.currentValue.OfferingId) {
        if (!subscriberOfferIds.includes(changesObj.offer.currentValue.OfferingId)) {
          subscriberOfferIds.push(changesObj.offer.currentValue.OfferingId);
        }
      }
      if (this.actions && subscriberOfferIds.length) {
        this.actions.retrieveOfferingsMetadata(subscriberOfferIds).catch(function (error) {
          _this.uiNotificationService.transientError(error.translatedMessage);
        });
      }
    }
  }, {
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      var controllerActions = {
        fetchCodeTypes: fetchCodeTypes,
        fetchSubscriberProductServiceRelationships: fetchSubscriberProductServiceRelationships,
        renewOffCycleCharges: renewOffCycleCharges,
        resumeOffer: resumeOffer,
        retrieveAvailablePaymentInstrumentTypes: retrieveAvailablePaymentInstrumentTypes,
        retrieveOfferingsMetadata: retrieveOfferingsMetadata,
        retrieveSubscriberOfferingDetail: retrieveSubscriberOfferingDetail,
        retrieveWallet: retrieveWallet,
        searchSubscriberOfferings: searchSubscriberOfferings,
        startEditOfferFlow: startEditOfferFlow,
        setSelectedOfferName: setSelectedOfferName,
        stateGo: stateGo,
        suspendOffer: suspendOffer,
        updateLifeCycleDetails: updateLifeCycleDetails,
        updateOfferingInstancePaymentInstrument: updateOfferingInstancePaymentInstrument,
        updateSubscriberProductServiceRelationships: updateSubscriberProductServiceRelationships
      };
      var mapStateToProps = function mapStateToProps(store) {
        return {
          businessUnitIsDbss: IsDbss(store),
          changeOfferEligibilityRules: ChangeOfferEligibilityRulesSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          hasAdminAccess: HasSubscriberAdminAccessSelector(store),
          lifeCyclePricingPlanDetails: LifeCyclePricingPlanDetailsSelector(store),
          offerAdditionalProperties: OfferAdditionalPropertiesSelector(store),
          offeringMetadataById: OfferingMetadataByIdSelector(store),
          offeringMetadataPricingPlans: OfferingMetadataPricingPlansSelector(store),
          paymentInstruments: PaymentInstrumentsCanBeUsedForOrderingWithTypeNamesViewModelSelector(store),
          pricingPlanInLifeCycleForOffers: PricingPlanInLifeCycleForOffersSelector(store),
          productServiceRelationships: ProductServiceRelationshipsSelector(store),
          routeParams: RouteParams(store),
          selectedOfferingInstanceId: SelectedSubscriberOfferingInstanceIdSelector(store),
          selectedOfferServiceIdentifiers: SearchSubscriberOfferingsDataSelector(store),
          selectedServiceDetailsOffering: SelectedServiceDetailsOfferOrderedOffering(store),
          serviceAdditionalProperties: SelectedServiceDetailsOfferOrderedOfferingAdditionalPropertiesSelector(store),
          serviceAttributesLoaded: MetadataCodeLoadedSelector(CODES.ServiceAttribute, store),
          serviceDetails: SelectedServiceDetailsSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToProps, controllerActions)(function (state, actions) {
        _this2.state = state;
        _this2.actions = actions;
      });
      this.lifeCycleDetailsPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this2.lifeCycleDetailsPopupConfigApi = api;
        }
      };
      this.modifyPaymentMethodPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this2.modifyPaymentMethodPopupApi = event.api;
        }
      };
      this.changePaymentPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this2.changePaymentPopupApi = event.api;
        }
      };
      this.productServiceRelationshipsModalConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this2.productServiceRelationshipsModalApi = event.api;
        }
      };
      this.editAdditionalAttributesModalConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this2.editAdditionalAttributesModalConfig = event.api;
        }
      };
      this.editAdditionalAttributesModalIsOpen = false;
      this.openPaymentMethodPopup = function () {
        var isEdit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        _this2.actions.retrieveAvailablePaymentInstrumentTypes().then(function () {
          _this2.isEditingPaymentInstrument = isEdit;
          _this2.modalPaymentMethod = clone(isEdit ? _this2.offer.PaymentInstrument : BLANK_PAYMENT_INSTRUMENT);
          _this2.isModifyPaymentMethodPopupShown = true;
          _this2.$timeout(function () {
            _this2.modifyPaymentMethodPopupApi.open();
          });
        }).catch(function (error) {
          uiNotificationService.transientError(error.translatedMessage);
        });
      };
      this.onCloseModifyPaymentMethodPopup = function () {
        _this2.modifyPaymentMethodPopupApi.close();
        _this2.isModifyPaymentMethodPopupShown = false;
      };
      this.openChangePaymentMethodPopup = function () {
        _this2.actions.retrieveWallet({
          customerId: _this2.state.currentCustomerId
        }).then(function () {
          _this2.showChangePaymentPopup = true;
          _this2.$timeout(function () {
            _this2.changePaymentPopupApi.open();
          });
        });
      };
      this.closeChangePaymentMethodPopup = function () {
        _this2.changePaymentPopupApi.close();
        _this2.showChangePaymentPopup = false;
      };
      this.onSuccessModifyPaymentMethodPopup = function () {
        _this2.refreshOfferDetails && _this2.refreshOfferDetails();
        _this2.refreshServiceDetails && _this2.refreshServiceDetails();
        _this2.onCloseModifyPaymentMethodPopup();
      };
      this.onChangePaymentMethod = function (paymentInstrument) {
        var paymentInstrumentId = paymentInstrument.Default ? null : paymentInstrument.Id;
        _this2.actions.updateOfferingInstancePaymentInstrument(_this2.state.currentCustomerId, _this2.offer.OfferingInstanceId, paymentInstrumentId).then(function () {
          _this2.uiNotificationService.success(i18n.translate(_this2.CustomerLocaleKeys.MAKE_PAYMENT.EDIT_INSTRUMENT_SUCCESS));
          _this2.refreshConvergentBillerDetails && _this2.refreshConvergentBillerDetails();
          _this2.refreshServiceDetails && _this2.refreshServiceDetails();
        }).catch(function (error) {
          _this2.uiNotificationService.transientError(error.translatedMessage);
        }).finally(function () {
          _this2.closeChangePaymentMethodPopup();
        });
      };
      if (!this.state.serviceAttributesLoaded) {
        this.actions.fetchCodeTypes(CODES.ServiceAttribute);
      }
    }
  }, {
    key: "closeLifeCycleDetailsPopup",
    value: function closeLifeCycleDetailsPopup() {
      this.lifeCycleDialogOpened = false;
      this.lifeCycleDetailsPopupConfigApi.close();
    }
  }, {
    key: "handleCloseEditAdditionalProperties",
    value: function handleCloseEditAdditionalProperties() {
      this.editAdditionalAttributesModalIsOpen = false;
      this.editAdditionalAttributesModalConfig.close();
    }
  }, {
    key: "submitAdditionalProperties",
    value: function submitAdditionalProperties() {
      this.uiNotificationService.success(i18n.translate(this.CustomerLocaleKeys.OFFER_ADDITIONAL_PROPERTIES_UPDATED_SUCCESSFULLY));
      this.refreshOfferDetails && this.refreshOfferDetails();
      this.refreshServiceDetails && this.refreshServiceDetails();
      this.handleCloseEditAdditionalProperties();
    }
  }, {
    key: "openLifeCycleDetailsPopup",
    value: function openLifeCycleDetailsPopup(option) {
      var _this3 = this;
      this.actions.updateLifeCycleDetails({
        offerId: option.OfferingId,
        lifeCycleId: option.LifeCycleDetail.LifeCycleId
      });
      this.pricingPlanInLifeCycleForOffers = this.state.pricingPlanInLifeCycleForOffers;
      this.lifeCyclePricingPlanDetails = Object.assign.apply(Object, [{}].concat(_toConsumableArray(this.state.lifeCyclePricingPlanDetails)));
      this.lifeCycleDialogOpened = true;
      this.currentLifeCycle = option.PricingPlanId;
      this.$timeout(function () {
        _this3.lifeCycleDetailsPopupConfigApi.open();
      });
    }
  }, {
    key: "navigateToPricingPlanEarlyRenewal",
    value: function navigateToPricingPlanEarlyRenewal(pricingPlan) {
      this.actions.stateGo(PRICING_PLAN_EARLY_RENEWAL_REDIRECT, {
        customerId: this.state.currentCustomerId,
        offeringInstanceId: pricingPlan === null || pricingPlan === void 0 ? void 0 : pricingPlan.OfferingInstanceId,
        subscriberProductId: pricingPlan === null || pricingPlan === void 0 ? void 0 : pricingPlan.SubscriberProductId
      });
    }
  }, {
    key: "openSuspendOfferModal",
    value: function openSuspendOfferModal(offerId) {
      this.suspendResumeOfferId = offerId;
      this.suspendResumeOrderType = +ORDER_TYPE_CODE.SUSPEND;
      this.suspendResumeModalTitle = i18n.translate(this.CustomerLocaleKeys.SUSPEND_OFFER);
      this.suspendResumeFormInstruction = i18n.translate(this.CustomerLocaleKeys.SUSPEND_OFFER_FORM_HINT);
      this.isSuspendResumeModalOpen = true;
    }
  }, {
    key: "openResumeOfferModal",
    value: function openResumeOfferModal(offerId) {
      this.suspendResumeOfferId = offerId;
      this.suspendResumeOrderType = +ORDER_TYPE_CODE.RESTORE;
      this.suspendResumeModalTitle = i18n.translate(this.CustomerLocaleKeys.RESUME_OFFER);
      this.suspendResumeFormInstruction = i18n.translate(this.CustomerLocaleKeys.RESUME_OFFER_FORM_HINT);
      this.isSuspendResumeModalOpen = true;
    }
  }, {
    key: "closeSuspendResumeModal",
    value: function closeSuspendResumeModal() {
      this.isSuspendResumeModalOpen = false;
    }
  }, {
    key: "openOfferingAutoRenewChangeModal",
    value: function openOfferingAutoRenewChangeModal(isEnableAutoRenew) {
      this.offeringAutoRenewEntityType = AUTO_RENEW_ENTITY_TYPES.OFFER;
      this.offeringAutoRenewAction = isEnableAutoRenew ? AUTO_RENEW_ACTION_TYPES.ENABLE : AUTO_RENEW_ACTION_TYPES.DISABLE;
      this.isOfferingAutoRenewChangeModalOpen = true;
    }
  }, {
    key: "closeOfferingAutoRenewChangeModal",
    value: function closeOfferingAutoRenewChangeModal() {
      this.isOfferingAutoRenewChangeModalOpen = false;
    }
  }, {
    key: "onOfferingAutoRenewChangeSubmit",
    value: function onOfferingAutoRenewChangeSubmit(_data, message) {
      this.uiNotificationService.transientSuccess(message);
      this.isOfferingAutoRenewChangeModalOpen = false;
      this.refreshOfferDetails && this.refreshOfferDetails();
    }
  }, {
    key: "submitSuspendResume",
    value: function submitSuspendResume(values) {
      var _this4 = this;
      var suspendResumeOrderType = this.suspendResumeOrderType === +ORDER_TYPE_CODE.SUSPEND ? this.actions.suspendOffer : this.actions.resumeOffer;
      var _values$OrderDetails = values.OrderDetails,
        ReasonCode = _values$OrderDetails.ReasonCode,
        OrderComment = _values$OrderDetails.OrderComment,
        ExecutionDate = values.BillingAndScheduling.ExecutionDate;
      suspendResumeOrderType(_objectSpread(_objectSpread({
        Comment: OrderComment,
        ReasonCode: ReasonCode
      }, this.suspendResumeOrderType === +ORDER_TYPE_CODE.SUSPEND ? {
        SuspensionStartDate: ExecutionDate
      } : {
        RestorationStartDate: ExecutionDate
      }), {}, {
        OfferingIdentifiers: [{
          Value: this.suspendResumeOfferId
        }]
      }), this.state.currentCustomerId).then(function () {
        _this4.uiNotificationService.transientSuccess(_this4.suspendResumeOrderType === +ORDER_TYPE_CODE.SUSPEND ? i18n.translate(_this4.CustomerLocaleKeys.SUSPEND_OFFER_SUBMITTED) : i18n.translate(_this4.CustomerLocaleKeys.RESUME_OFFER_SUBMITTED));
      }).catch(function (error) {
        _this4.uiNotificationService.transientError(error.translatedMessage);
      });
      this.closeSuspendResumeModal();
      this.suspendResumeOfferId = null;
    }
  }, {
    key: "onMoreItemSelected",
    value: function onMoreItemSelected(option) {
      var _this5 = this;
      switch (option.id) {
        case MENU_ITEMS.ADD_ANOTHER_OFFER:
          this.$state.go(ADD_OFFER_STATE, {
            customerId: this.state.currentCustomerId
          });
          break;
        case MENU_ITEMS.RECONNECT_OFFER:
          this.actions.stateGo(RECONNECT_OFFER_STATE_NAME, {
            offeringId: this.offer.OfferingId,
            offeringInstanceId: this.offer.OfferingInstanceId,
            contractId: this.offer.OrderContractInstance ? this.offer.OrderContractInstance.OrderContractId : null,
            contractInstanceId: this.offer.OrderContractInstance ? this.offer.OrderContractInstance.Id : null
          });
          break;
        case MENU_ITEMS.DISCONNECT_OFFER:
          if (this.state.businessUnitIsDbss) {
            this.actions.stateGo(DISCONNECT_OFFERS_DBSS_ROUTE, {
              offeringId: this.offer.OfferingId,
              offeringInstanceId: this.offer.OfferingInstanceId
            });
          } else {
            this.actions.stateGo(DISCONNECT_OFFERS_ITV_ROUTE);
          }
          break;
        case MENU_ITEMS.REMOVE_OFFER:
          this.$state.go(CUSTOMER_REMOVE_OFFER_URL, {
            offeringId: this.offer.OfferingId,
            offeringInstanceId: this.offer.OfferingInstanceId,
            subscriptionId: this.offer.Subscription.Id,
            currency: this.currencyCode
          });
          break;
        case MENU_ITEMS.EDIT_OFFER:
          if (!this.hasSomeSuspendedOptions) {
            this.actions.startEditOfferFlow(this.offer.DisplayName);
            this.$state.go(this.offer.InstanceLevelOrdered ? EDIT_OFFERING_INSTANCES : EDIT_OFFER_STATE, _objectSpread({
              offeringId: this.offer.OfferingId,
              offeringInstanceId: this.offer.OfferingInstanceId
            }, !this.offer.InstanceLevelOrdered && {
              contractId: this.offer.OrderContractInstance ? this.offer.OrderContractInstance.OrderContractId : null,
              contractInstanceId: this.offer.OrderContractInstance ? this.offer.OrderContractInstance.Id : null
            }));
          }
          break;
        case MENU_ITEMS.CHANGE_OFFER:
          {
            var currentOfferEligibilityRules = this.state.changeOfferEligibilityRules.find(function (changeOffer) {
              return changeOffer.OfferingInstanceId === _this5.offer.OfferingInstanceId;
            });
            var isEligible = offerIsEligible(this.offer, currentOfferEligibilityRules);
            if (isEligible && !this.hasSomeSuspendedOptions) {
              this.actions.setSelectedOfferName(this.offer.DisplayName);
              this.$state.go(TRANSITION_OFFER_STATE, {
                offeringId: this.offer.OfferingId,
                offeringInstanceId: this.offer.OfferingInstanceId
              });
            }
            break;
          }
        case MENU_ITEMS.RETRY_PAYMENT:
          {
            var offCycleFailures = getOrderIdAndSubscriberProductIds(this.offer);
            this.actions.renewOffCycleCharges(this.state.currentCustomerId, offCycleFailures.subscriberProductIds, offCycleFailures.orderId).then(function () {
              _this5.refreshConvergentBillerDetails && _this5.refreshConvergentBillerDetails();
            }).catch(function (error) {
              _this5.uiNotificationService.transientError(error.translatedMessage);
            });
            break;
          }
        case MENU_ITEMS.ADD_PAYMENT_INSTRUMENT:
          this.openPaymentMethodPopup(false);
          break;
        case MENU_ITEMS.EDIT_PAYMENT_INSTRUMENT:
          this.openPaymentMethodPopup(true);
          break;
        case MENU_ITEMS.CHANGE_PAYMENT_INSTRUMENT:
          this.openChangePaymentMethodPopup();
          break;
        case MENU_ITEMS.VIEW_OFFER_DETAILS:
          this.$state.go(OFFERINGS_STATE_NAME, {
            offeringInstanceId: this.offer.OfferingInstanceId
          });
          break;
        case MENU_ITEMS.MANAGE_PLAN_SERVICES:
          this.openProductServiceRelationshipsModal();
          break;
        case MENU_ITEMS.SUSPEND_OFFER:
          this.openSuspendOfferModal(this.offer.OfferingId);
          break;
        case MENU_ITEMS.RESUME_OFFER:
          this.openResumeOfferModal(this.offer.OfferingId);
          break;
        case MENU_ITEMS.EDIT_ADDITIONAL_PROPERTIES:
          {
            var _this$state$selectedS;
            this.editOfferOfferingInstanceId = (_this$state$selectedS = this.state.selectedServiceDetailsOffering) === null || _this$state$selectedS === void 0 ? void 0 : _this$state$selectedS.OfferingInstanceId;
            this.editOfferAdditionalProperties = this.state.serviceAdditionalProperties;
            this.editAdditionalAttributesModalIsOpen = true;
            this.editAdditionalAttributesModalConfig.open();
            break;
          }
        case MENU_ITEMS.EDIT_OFFER_ADDITIONAL_PROPERTIES:
          {
            this.editOfferOfferingInstanceId = this.state.selectedOfferingInstanceId;
            this.editOfferAdditionalProperties = this.state.offerAdditionalProperties;
            this.editAdditionalAttributesModalIsOpen = true;
            this.editAdditionalAttributesModalConfig.open();
            break;
          }
        case MENU_ITEMS.MAKE_EARLY_RENEWAL_PAYMENT:
          {
            this.actions.stateGo(PRICING_PLAN_EARLY_RENEWAL_REDIRECT, {
              customerId: this.state.currentCustomerId,
              offeringInstanceId: this.offer.OfferingInstanceId
            });
            break;
          }
        case MENU_ITEMS.ENABLE_AUTO_RENEW:
          {
            this.openOfferingAutoRenewChangeModal(true);
            break;
          }
        case MENU_ITEMS.DISABLE_AUTO_RENEW:
          {
            this.openOfferingAutoRenewChangeModal(false);
            break;
          }
        case MENU_ITEMS.SUSPEND_SUBSCRIBER_PRODUCT:
          {
            this.actions.stateGo(SUSPEND_SUBSCRIBER_PRODUCTS_REDIRECT, {
              customerId: this.state.currentCustomerId,
              offeringId: this.offer.OfferingId,
              offeringInstanceId: this.offer.OfferingInstanceId
            });
            break;
          }
        case MENU_ITEMS.RESUME_SUBSCRIBER_PRODUCT:
          {
            this.actions.stateGo(RESUME_SUBSCRIBER_PRODUCTS_REDIRECT, {
              customerId: this.state.currentCustomerId,
              offeringId: this.offer.OfferingId,
              offeringInstanceId: this.offer.OfferingInstanceId
            });
            break;
          }
        default:
          break;
      }
    }
  }, {
    key: "openProductServiceRelationshipsModal",
    value: function openProductServiceRelationshipsModal() {
      var _this6 = this;
      this.actions.fetchSubscriberProductServiceRelationships(this.state.currentCustomerId).then(function () {
        var allOfferingIds = [];
        (_this6.state.productServiceRelationships || []).forEach(function (services) {
          allOfferingIds.push(services.OfferingId.Value);
          (services.LinkableProviderPlans || []).forEach(function (providerPlans) {
            allOfferingIds.push(providerPlans.OfferingId.Value);
          });
        });
        _this6.actions.retrieveOfferingsMetadata(uniq(allOfferingIds)).then(function () {
          _this6.offeringMetadataLoaded = true;
        }).catch(function (error) {
          _this6.uiNotificationService.transientError(error.translatedMessage);
        });
        _this6.isProductServiceRelationshipsModalShown = true;
        _this6.$timeout(function () {
          _this6.productServiceRelationshipsModalApi.open();
        });
      }).catch(function (error) {
        _this6.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "onCloseProductServiceRelationshipsModal",
    value: function onCloseProductServiceRelationshipsModal() {
      this.productServiceRelationshipsModalApi.close();
      this.isProductServiceRelationshipsModalShown = false;
    }
  }, {
    key: "onSubmitProductServiceRelationshipsModal",
    value: function onSubmitProductServiceRelationshipsModal(productServiceRelationships) {
      var _this7 = this;
      this.actions.updateSubscriberProductServiceRelationships(this.state.currentCustomerId, productServiceRelationships).then(function () {
        _this7.onCloseProductServiceRelationshipsModal();
        _this7.uiNotificationService.success(i18n.translate(_this7.CustomerLocaleKeys.PRODUCT_SERVICE_RELATIONSHIP.SUCCESS));
        if (_this7.displaySubscriberOfferComponent) {
          _this7.refreshOfferDetails && _this7.refreshOfferDetails();
        } else {
          _this7.refreshServiceDetails && _this7.refreshServiceDetails();
        }
        _this7.refreshConvergentBillerDetails && _this7.refreshConvergentBillerDetails();
      }).catch(function (error) {
        _this7.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }]);
}();
export default {
  bindings: {
    currencyCode: '<',
    displaySubscriberOfferComponent: '<?',
    offer: '<',
    refreshOfferDetails: '&?',
    refreshServiceDetails: '&?',
    refreshConvergentBillerDetails: '&?',
    serviceIdentifier: '<?'
  },
  template: require('./offer.details.html'),
  controller: OfferDetailsController
};